import getDeleteCookieString from './getDeleteCookieString';

export default function deleteCookie(params) {
  const toDelete = getDeleteCookieString(params);

  if (toDelete) {
    document.cookie = toDelete;
  }
}
